import React from 'react';
import './ImagenProyecto.css';

const ImagenProyecto = () => {
  return (
    <section className="imagen-proyecto-section">
      <div className="image-container">
        <img
          src="/images/tableroprediccion.png"
          alt="Tablero de predicción de Gestas ML"
          className="main-image"
        />
        <img
          src="/images/exitoprediccion.png"
          alt="Éxito en la predicción"
          className="overlay-image"
        />
      </div>
    </section>
  );
};

export default ImagenProyecto;